import { toNaturalSentence } from "../../../../utils/string";
import demystLogo from "../../../assets/datasourceLogos/demyst.png";
import Image from "next/image";
import { FiBookOpen, FiMoreHorizontal, FiTrash } from "react-icons/fi";
import { CategoryLogo } from "./CategoryLogo";
import { RegionLogo } from "./RegionLogo";
import AwsLogo from "../../../assets/svg/AwsLogo.svg";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import ClickAwayListener from "react-click-away-listener";
import { animatePresenceConfig } from "../../../../config/appConfig";
import { linksConstants } from "../../../../constants/linksConstants";

export const ConnectorCard = ({ data, connectorRemoved }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <section className="ConnectorCard">
      <section className="ConnectorCard__header">
        <section className="ConnectorCard__menu__container">
          <button
            className={`ConnectorCard__menu ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(true)}
          >
            <FiMoreHorizontal />
          </button>
          <AnimatePresence>
            {menuOpen && (
              <ClickAwayListener onClickAway={() => setMenuOpen(false)}>
                <motion.div {...animatePresenceConfig}>
                  <div className="ConnectorCard__menu__list">
                    <a
                      href={`${linksConstants.CONNECTOR_ROOT}/${data.id}`}
                      alt={`Link to ${linksConstants.CONNECTOR_ROOT}/${data.id}`}
                      target="_blank"
                      rel="noreferrer"
                      className="ConnectorCard__menu__list__item"
                    >
                      <FiBookOpen />
                      View in Catalog
                    </a>
                    <button
                      onClick={() => connectorRemoved(data.id)}
                      className="ConnectorCard__menu__list__item"
                    >
                      <FiTrash />
                      Remove Connector
                    </button>
                  </div>
                </motion.div>
              </ClickAwayListener>
            )}
          </AnimatePresence>
        </section>
        <div className="ConnectorCard__logos">
          {data.logo ? (
            data.logo.indexOf("blue_dot") === -1 ? (
              <img
                className="ConnectorCard__connectorImage"
                src={data.logo}
                alt={`${data.data_source?.name?.replace(/_/g, " ")} logo`}
                loading="eager"
                height="40"
                width="40"
              />
            ) : (
              <Image
                className="ConnectorCard__connectorImage"
                src={demystLogo}
                alt="Demyst logo"
                width="40"
                height="40"
              />
            )
          ) : (
            <Image
              className="ConnectorCard__connectorImage"
              src={demystLogo}
              alt="Demyst logo"
              width="40"
              height="40"
            />
          )}
          <p className="ConnectorCard__source">
            {data.data_source ? toNaturalSentence(data.data_source.name) : "Undefined"}
          </p>
        </div>
      </section>
      <h3 className="ConnectorCard__name">
        {data.alias ? data.alias : toNaturalSentence(data.name)}
      </h3>
      <p className="ConnectorCard__description">
        {data.description || <em>No description provided</em>}
      </p>
      <section className="DataCatalogItem__tags">
        {data.data_regions?.map(region => (
          <div key={region.name} className="DataCatalogItem__tag">
            <div className="DataCatalogItem__logoContainer">
              <RegionLogo name={region.name} />
            </div>
            <span>{region.name}</span>
          </div>
        ))}
        {data.data_category && (
          <div className="DataCatalogItem__tag">
            <CategoryLogo category={data.data_category?.name} />
            <span>{data.data_category?.name}</span>
          </div>
        )}
        {data.adx_flag && (
          <div className="DataCatalogItem__awsTag">
            <img src={AwsLogo} alt="AWS Amazon Data Exchange Enabled" />
          </div>
        )}
      </section>
    </section>
  );
};
